import * as React from "react";
import { Grid, Typography, Paper, Divider } from "@material-ui/core";
import StorefrontIcon from "@material-ui/icons/Storefront";
import { PHARMACY_DETAILS } from "../config/PrescriptionDefaults";

const PharmacyDetails: React.FC = () => {
  return (
    <Grid item xs={12}>
      <Paper
        style={{ padding: 24, backgroundColor: "#f5f5f5", borderRadius: 8 }}
      >
        <Typography
          variant="h6"
          gutterBottom
          style={{
            color: "black",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <StorefrontIcon style={{ color: "#546e7a" }} />
          Pharmacy Details
        </Typography>
        <Typography
          variant="caption"
          color="textSecondary"
          style={{ display: "block", marginBottom: 16 }}
        >
          Source of Truth - Read Only
        </Typography>
        <Divider style={{ marginBottom: 20 }} />

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper
              style={{
                padding: 16,
                backgroundColor: "#ffffff",
                borderLeft: "4px solid #546e7a",
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                  >
                    NPI
                  </Typography>
                  <Typography variant="body2" style={{ fontWeight: 500 }}>
                    {PHARMACY_DETAILS.NPI}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                  >
                    NCPDP ID
                  </Typography>
                  <Typography variant="body2" style={{ fontWeight: 500 }}>
                    {PHARMACY_DETAILS.NCPDPID}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default PharmacyDetails;
